<template>
    <div class="analytics-num-practice-comparative">
        <div class="analytics-num-practice-comparative__current-period">
            <span class="analytics-num-practice-comparative__current-period-icon"></span>
            <div class="analytics-num-practice-comparative__wr-current-period-text">
                <template v-if="!showPreloader">
                    <span class="analytics-num-practice-comparative__current-period-value">{{ filteredNumpracticeComparativeData.current.numPractice }} pratik</span>
                    <span class="analytics-num-practice-comparative__current-period-label">{{ textCurrentPeriodLabel }}</span>
                </template>
                <div
                    v-if="showPreloader"
                    class="analytics-num-practice-comparative__preloader"></div>
            </div>
        </div>
        <div class="analytics-num-practice-comparative__previous-period">
            <span class="analytics-num-practice-comparative__previous-period-icon"></span>
            <div class="analytics-num-practice-comparative__wr-previous-period-text">
                <template v-if="!showPreloader">
                    <span class="analytics-num-practice-comparative__previous-period-value">{{ filteredNumpracticeComparativeData.previous.numPractice }} pratik</span>
                    <span class="analytics-num-practice-comparative__previous-period-label">{{ textPreviousPeriodLabel }}</span>
                </template>
                <div
                    v-if="showPreloader"
                    class="analytics-num-practice-comparative__preloader"></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            filteredNumpracticeComparativeData(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.practiceStreak.type;
                return this.$store.state.response.analyticsPractice.numPracticeComparativeData[selectedFiltertagType];
            },

            textCurrentPeriodLabel(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.practiceStreak.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'bu hafta #' + this.filteredNumpracticeComparativeData.current.period;
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'bu ay: ' + this.filteredNumpracticeComparativeData.current.period;
                }
            },

            textPreviousPeriodLabel(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.practiceStreak.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'geçen hafta #' + this.filteredNumpracticeComparativeData.previous.period;
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'geçen ay: ' + this.filteredNumpracticeComparativeData.previous.period;
                }
            },
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsNumPracticeComparative)
                .then(response => response.json())
                .then(numPracticeComparativeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPractice',
                        dataLabel: 'numPracticeComparativeData',
                        data: numPracticeComparativeData
                    });
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsPracticeNumPracticeComparative, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(numPracticeComparativeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPractice',
                        dataLabel: 'numPracticeComparativeData',
                        data: numPracticeComparativeData
                    });
                    this.showPreloader = false;
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                })
            }
        }
    };
</script>
<style scoped src="@/css/components/analytics-num-practice-comparative.css"></style>